import React from "react";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {
      event: this.props.event,
    };
  },
  onError() {
    var updated = this.state.event;
    updated.main_image_url_medium = "/images/ja2/img_noimage.gif";
    this.setState({
      event: updated,
    });
  },
  render() {
    var event = this.state.event;
    return (
      <div>
        <a
          href={`/event/${event.id}`}
          className="list-group-item circle-list-item no-padding"
        >
          <div className="media">
            <div className="media-left">
              <div
                className="circle-list-img-wrap"
                style={{ width: "100px", height: "100px" }}
              >
                <img src={event.main_image_url_medium} onError={this.onError} />
              </div>
            </div>
            <div
              className="media-body"
              style={{ textAlign: "left", width: "100%" }}
            >
              <h4
                className="color-main-strong line-1"
                style={{ fontSize: "25px", lineHeight: "1" }}
              >
                {event.event_date_formatted}
              </h4>
              <h6 className="circle_name line-1" style={{ fontSize: "15px" }}>
                {event.title}
              </h6>
              <div className="list-group-item-text line-1">
                <span style={{ fontSize: "8px", color: "rgb(102, 102, 102)" }}>
                  {event.circle && event.circle.name}
                </span>
              </div>
            </div>
          </div>
        </a>
      </div>
    );
  },
});
